/**
 * Global client-side error handler.
 *
 * Catches unhandled Vue errors and Axios failures that happen on the
 * client after the static HTML has been served.  These are invisible to
 * server-side logging; we surface them in the console and, for Axios
 * errors, prevent a full error-page blow-up by returning a safe fallback.
 */
import Vue from 'vue'

export default ({ app, $axios }) => {
  // ── Vue global error handler ──────────────────────────────────────────
  const originalHandler = Vue.config.errorHandler

  Vue.config.errorHandler = (err, vm, info) => {
    console.error('[vue-error-handler]', {
      message: err && err.message,
      stack: err && err.stack,
      info,
      route: (app.router && app.router.currentRoute && app.router.currentRoute.fullPath) || '',
    })

    if (typeof originalHandler === 'function') {
      originalHandler(err, vm, info)
    }
  }

  // ── Axios client-side error interceptor ───────────────────────────────
  // Only runs in the browser.  During nuxt generate the server-side
  // debug-axios.js plugin handles logging.  On the client the typical
  // scenario where Axios fires is a payload-loading fallback (the browser
  // couldn't fetch the static payload.js and Nuxt retried the real API).
  if ($axios) {
    $axios.onError((error) => {
      const err = error || {}
      const config = err.config || {}

      console.error('[client-axios-error]', {
        url: config.url || null,
        baseURL: config.baseURL || null,
        status: (err.response && err.response.status) || null,
        message: err.message || String(error),
        route: window.location.href,
      })

      return Promise.reject(error)
    })
  }
}
